import React, { useState } from "react";
import "../Style/CompanySettings.css";
import MainSidebar from "./Mainsidebar";
import UserNavbar from "./UserNavbar";
import UserFooter from "./UserFooter";
import General from "./Company_Setiing/General";
import DefaultValue from "./Company_Setiing/DefaultValue";
import Shipping from "./Company_Setiing/Shipping";
import Payment from "./Company_Setiing/Payment";

const TAB_GENERAL = "general";
const TAB_DEFAULT = "default-value";
const TAB_PAYMENT = "payment";
const TAB_SHIPPING = "shipping";
const TAB_EFILING = "e-filing";
const TAB_TAX = "tax-information";
const TAB_BADGE = "company-badge";
const TAB_UX = "user-experience";

export default function Company() {
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [activeTab, setActiveTab] = useState(TAB_GENERAL);

  const handleScreenEnter = () => { setFullScreen(false); document.body.requestFullscreen(); };
  const handleScreenExit = () => { setFullScreen(true); document.exitFullscreen(); };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) return { width: "100%", left: "0rem" };
    else return { width: !hamburger && "-webkit-fill-available", left: !hamburger && "3.7rem" };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) { return { display: hamburger && "none" }; }
  };

  const handleTabClick = (tab) => setActiveTab(tab);

  const navItem = (tabKey, label) => (
    <a key={tabKey} className={"nav-link " + (activeTab === tabKey ? "active" : "")} onClick={() => handleTabClick(tabKey)}>{label}</a>
  );

  return (
    <div className="con1 d-flex">
      <div className="subcon1" style={handleclickonbutton1(hamburger)}>
        <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
      </div>
      <div className="subcon2" style={handleclickonbutton(hamburger)}>
        <UserNavbar
          hamburger={hamburger}
          sethamburger={sethamburger}
          handelRightMenuShow={handelRightMenuShow}
          handelShow={handelShow}
          isSearchShow={isSearchShow}
          handleScreenEnter={handleScreenEnter}
          handleScreenExit={handleScreenExit}
          fullScreen={fullScreen}
        />
        <div className="min-vh-100">
          <div className="card card-primary card-outline m-4">
            <div className="card-header">
              <h3 className="card-title"><i className="fa-solid fa-briefcase pr-2"></i>Company Settings</h3>
            </div>
            <div className="card-body p-4">
              <div className="row">
                <div className="col-12 col-md-3 col-lg-2 p-0">
                  <div className="nav flex-column cs-nav">
                    {navItem(TAB_GENERAL, "General")}
                    {navItem(TAB_DEFAULT, "Default Value")}
                    {navItem(TAB_PAYMENT, "Payment")}
                    {navItem(TAB_SHIPPING, "Shipping")}
                    {navItem(TAB_EFILING, "E-Filing")}
                    {navItem(TAB_TAX, "Tax Information")}
                    {navItem(TAB_BADGE, "Company Badge")}
                    {navItem(TAB_UX, "User Experience")}
                  </div>
                </div>
                <div className="col-12 col-md-9 col-lg-10 p-0">
                  <div className="tab-content" style={{ overflowY: "auto", maxHeight: "calc(100vh - 130px)", padding: "0 0 0 24px" }}>
                    <div className={"tab-pane " + (activeTab === TAB_GENERAL ? "cs-pane-active" : "")}><General /></div>
                    <div className={"tab-pane " + (activeTab === TAB_DEFAULT ? "cs-pane-active" : "")}><DefaultValue /></div>
                    <div className={"tab-pane " + (activeTab === TAB_PAYMENT ? "cs-pane-active" : "")}><Payment /></div>
                    <div className={"tab-pane " + (activeTab === TAB_SHIPPING ? "cs-pane-active" : "")}><Shipping /></div>
                    <div className={"tab-pane " + (activeTab === TAB_EFILING ? "cs-pane-active" : "")}>
                      <p style={{ color: "#6c757d", fontSize: "14px", lineHeight: 1.6, maxWidth: "560px" }}>E-Filing settings will let you configure electronic filing preferences for tax and compliance documents. This section is coming soon.</p>
                    </div>
                    <div className={"tab-pane " + (activeTab === TAB_TAX ? "cs-pane-active" : "")}>
                      <p style={{ color: "#6c757d", fontSize: "14px", lineHeight: 1.6, maxWidth: "560px" }}>Tax Information settings will let you configure tax rates, registration numbers, and jurisdiction rules. This section is coming soon.</p>
                    </div>
                    <div className={"tab-pane " + (activeTab === TAB_BADGE ? "cs-pane-active" : "")}>
                      <p style={{ color: "#6c757d", fontSize: "14px", lineHeight: 1.6, maxWidth: "560px" }}>Company Badge settings will let you customize the badge/certification displayed on your company profile. This section is coming soon.</p>
                    </div>
                    <div className={"tab-pane " + (activeTab === TAB_UX ? "cs-pane-active" : "")}>
                      <p style={{ color: "#6c757d", fontSize: "14px", lineHeight: 1.6, maxWidth: "560px" }}>User Experience settings will let you configure theme, density, and accessibility preferences. This section is coming soon.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <UserFooter />
      </div>
    </div>
  );
}